import { downloadFile } from '@mi-front/core';
import { apiClient } from '../../../api';
import { Fragment } from '../types';

export const downloadFragmentAudio = async (fragment: Fragment) => {
  const { url } = await apiClient.fragments.generateDownloadUrl(fragment.id);

  downloadFile(url, false);
};

export const getFragmentUrl = async (fragment: Fragment | string) => {
  const { url } = await apiClient.fragments.generateDownloadUrl(
    typeof fragment === 'string' ? fragment : fragment.id,
  );

  return url;
};
